import { gql } from "@apollo/client";

export const CREATE_SHAREABLE_LINK = gql`
  mutation CreateShareableLink($input: CreateShareableLinkInput!) {
    createShareableLink(input: $input) {
      link
    }
  }
`;
